import PromptBox from './PromptBox';

export default PromptBox;
